import {mainNavigation} from './navigation';
import {accessibility} from './accessibility';
import {helpers} from './helpers';

mainNavigation();
accessibility();
helpers();